<template>
    <transition name="remote-pop">
        <div class="desktop-remote" v-if="open" @click.stop :class="[type, { 'has-media': !!media }]" :style="{ '--accent': accentColor }">

            <div class="remote-glow" v-if="media"></div>

            <div class="remote-header">
                <button class="device-trigger" v-if="media" @click="toggleDidDrawer" :class="{ active: didDrawerOpen }">
                    <div class="device-art" v-if="headerArt">
                        <img :src="headerArt" @error="fallbackImg" />
                    </div>
                    <div class="device-text">
                        <span class="device-name">{{ media.name || media.title }}</span>
                        <span class="device-meta">
                            <i class="live-dot" v-if="type === 'live'"></i>
                            {{ media.did }}
                        </span>
                    </div>
                    <svg class="chev" :class="{ open: didDrawerOpen }" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </button>

                <div class="no-device" v-else>
                    <span>No active device</span>
                </div>

                <div class="header-actions">
                    <button class="icon-btn" v-if="media" @click="toggleActionDrawer" :class="{ active: actionDrawerOpen }" v-ripple title="More options">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 18.5C12.2761 18.5 12.5 18.2761 12.5 18C12.5 17.7239 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.7239 11.5 18C11.5 18.2761 11.7239 18.5 12 18.5Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </button>
                    <button class="icon-btn close-btn" @click="$emit('close')" v-ripple title="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>

            <transition name="fade">
                <div class="drawer did-drawer" v-if="didDrawerOpen && media">
                    <DidSettings :did="media.did" :inline="true" />
                </div>
            </transition>

            <transition name="fade">
                <div class="drawer action-drawer" v-if="actionDrawerOpen">
                    <button class="drawer-item" @click="fullscreen" v-ripple>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"> <path d="M9 9L4 4M4 4V8M4 4H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 9L20 4M20 4V8M20 4H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M9 15L4 20M4 20V16M4 20H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15 15L20 20M20 20V16M20 20H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        <span>Toggle fullscreen</span>
                    </button>
                    <button class="drawer-item" @click="toggleAT" v-ripple>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"> <path d="M2 5H9M16 5H13.5M9 5L13.5 5M9 5V3M13.5 5C12.6795 7.73513 10.9612 10.3206 9 12.5929M4 17.5C5.58541 16.1411 7.376 14.4744 9 12.5929M9 12.5929C8 11.5 6.4 9.3 6 8.5M9 12.5929L12 15.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M13.5 21L14.6429 18M21.5 21L20.3571 18M14.6429 18L17.5 10.5L20.3571 18M14.6429 18H20.3571" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        <span>Change language</span>
                    </button>
                    <button class="drawer-item" @click="toggleCC" v-ripple>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"> <path d="M7.5 22C10.5376 22 13 19.5376 13 16.5C13 13.4624 10.5376 11 7.5 11C4.46243 11 2 13.4624 2 16.5C2 17.5018 2.26783 18.441 2.7358 19.25L2.275 21.725L4.75 21.2642C5.55898 21.7322 6.49821 22 7.5 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15.2824 17.8978C16.2587 17.7405 17.1758 17.4065 18 16.9297L21.6 17.6L20.9297 14C21.6104 12.8233 22 11.4571 22 10C22 5.58172 18.4183 2 14 2C9.97262 2 6.64032 4.97598 6.08221 8.84884" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        <span>Closed captions</span>
                    </button>
                    <button class="drawer-item" @click="getBack" v-ripple v-if="media && media.ref">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"> <path d="M8 21H20.4C20.7314 21 21 20.7314 21 20.4V3.6C21 3.26863 20.7314 3 20.4 3H3.6C3.26863 3 3 3.26863 3 3.6V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.5 20.5L12 12M12 12V16M12 12H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        <span>Go to source</span>
                    </button>
                </div>
            </transition>

            <div class="drawer-catch" v-if="didDrawerOpen || actionDrawerOpen || gameToolDrawerOpen" @click="closeAllDrawers"></div>

            <template v-if="media">
                <div class="remote-body">

                    <div class="media-art" :class="{ duel: isDuel, poster: isPoster, single: !isDuel && !isPoster }">
                        <template v-if="type === 'sport' && isDuel">
                            <div class="team-logo">
                                <img :src="media.logos[0]" @error="fallbackImg" />
                            </div>
                            <span class="vs-chip">vs</span>
                            <div class="team-logo">
                                <img :src="media.logos[1]" @error="fallbackImg" />
                            </div>
                        </template>
                        <template v-else-if="type === 'sport'">
                            <div class="team-logo multi" v-for="(logo, i) in media.logos" :key="i">
                                <img :src="logo" @error="fallbackImg" />
                            </div>
                        </template>
                        <template v-else-if="media.logos && media.logos[0]">
                            <img :src="media.logos[0]" @error="fallbackImg" />
                        </template>
                    </div>

                    <div class="media-title-row">
                        <button class="chan-btn" v-if="type === 'live'" @click="prev" v-ripple title="Previous channel">
                            <svg style="transform: scaleX(-1)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"> <path d="M2.95592 5.70436C2.55976 5.41246 2 5.69531 2 6.1874V17.8126C2 18.3047 2.55976 18.5875 2.95592 18.2956L10.8445 12.483C11.1699 12.2432 11.1699 11.7568 10.8445 11.517L2.95592 5.70436Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M13.9559 5.70436C13.5598 5.41246 13 5.69531 13 6.1874V17.8126C13 18.3047 13.5598 18.5875 13.9559 18.2956L21.8445 12.483C22.1699 12.2432 22.1699 11.7568 21.8445 11.517L13.9559 5.70436Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>

                        <div class="media-title">
                            <span class="type-tag">
                                <svg v-if="type === 'live'" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="17" r="1.6" fill="currentColor"/><path d="M8.2 13.2a5.5 5.5 0 017.6 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M5 10a10 10 0 0114 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                                <svg v-else-if="type === 'sport'" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M7 4h10v3.2a5 5 0 01-10 0V4z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 5H4.5A2.5 2.5 0 007 7.5M17 5h2.5A2.5 2.5 0 0117 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M12 12.2V17M8.5 20.5h7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                                <svg v-else-if="type === 'game'" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"><rect x="3" y="8" width="18" height="9" rx="4" stroke="currentColor" stroke-width="1.5"/><path d="M7.5 10.5v4M5.5 12.5h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="15.5" cy="11.5" r="0.9" fill="currentColor"/><circle cx="17.5" cy="13.5" r="0.9" fill="currentColor"/></svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="16" rx="3" stroke="currentColor" stroke-width="1.5"/><path d="M10 9l5 3-5 3V9z" fill="currentColor"/></svg>
                                {{ typeLabel }}
                            </span>
                            <h3>{{ media.name || media.title }}</h3>
                        </div>

                        <button class="chan-btn" v-if="type === 'live'" @click="next" v-ripple title="Next channel">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"> <path d="M2.95592 5.70436C2.55976 5.41246 2 5.69531 2 6.1874V17.8126C2 18.3047 2.55976 18.5875 2.95592 18.2956L10.8445 12.483C11.1699 12.2432 11.1699 11.7568 10.8445 11.517L2.95592 5.70436Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M13.9559 5.70436C13.5598 5.41246 13 5.69531 13 6.1874V17.8126C13 18.3047 13.5598 18.5875 13.9559 18.2956L21.8445 12.483C22.1699 12.2432 22.1699 11.7568 21.8445 11.517L13.9559 5.70436Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>
                    </div>

                    <div class="scrub" v-if="type === 'od'">
                        <div class="scrub-track" ref="scrubTrack" @mousedown="onScrubStart" :class="{ dragging: isDragging }">
                            <div class="scrub-fill" :style="{ width: progress + '%' }"></div>
                            <div class="scrub-thumb" :style="{ left: progress + '%' }"></div>
                        </div>
                        <div class="scrub-times" v-if="media.duration">
                            <span>{{ formatTime(currentTime) }}</span>
                            <span>-{{ formatTime(media.duration - currentTime) }}</span>
                        </div>
                    </div>

                    <div class="transport" :class="{ disabled: disableControls }" v-if="type !== 'game'">
                        <button class="ctrl sm safe" @click="stop" v-ripple title="Stop">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"> <path d="M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>

                        <button class="ctrl" @click="rw" v-ripple title="Rewind">
                            <svg style="transform: scaleX(-1);" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"> <path d="M21.8883 13.5C21.1645 18.3113 17.013 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C16.1006 2 19.6248 4.46819 21.1679 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M17 8H21.4C21.7314 8 22 7.73137 22 7.4V3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>

                        <button class="ctrl primary" @click="togglePlayPause" v-ripple title="Play/Pause">
                            <svg v-if="!playing" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M6.90588 4.53682C6.50592 4.2998 6 4.58808 6 5.05299V18.947C6 19.4119 6.50592 19.7002 6.90588 19.4632L18.629 12.5162C19.0211 12.2838 19.0211 11.7162 18.629 11.4838L6.90588 4.53682Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path d="M6 18.4V5.6C6 5.26863 6.26863 5 6.6 5H9.4C9.73137 5 10 5.26863 10 5.6V18.4C10 18.7314 9.73137 19 9.4 19H6.6C6.26863 19 6 18.7314 6 18.4Z" stroke="currentColor" stroke-width="1.5"/> <path d="M14 18.4V5.6C14 5.26863 14.2686 5 14.6 5H17.4C17.7314 5 18 5.26863 18 5.6V18.4C18 18.7314 17.7314 19 17.4 19H14.6C14.2686 19 14 18.7314 14 18.4Z" stroke="currentColor" stroke-width="1.5"/> </svg>
                        </button>

                        <button class="ctrl" v-if="showOrMovie && progress < 25 && media.details && media.details.contentType === 'tv'" @click="skipIntro" v-ripple title="Skip intro">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"> <path d="M17 13H12V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M5 3.5L7 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M19 3.5L17 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12 22C16.9706 22 21 17.9706 21 13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13C3 17.9706 7.02944 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>
                        <button class="ctrl" v-else-if="showOrMovie && progress > 85 && media.duration > 0" @click="next" v-ripple title="Next episode">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"> <path d="M18 7V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.97179 5.2672C6.57832 4.95657 6 5.23682 6 5.73813V18.2619C6 18.7632 6.57832 19.0434 6.97179 18.7328L14.9035 12.4709C15.2078 12.2307 15.2078 11.7693 14.9035 11.5291L6.97179 5.2672Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>
                        <button class="ctrl" v-else-if="showOrMovie" @click="ff" v-ripple title="Forward">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"> <path d="M21.8883 13.5C21.1645 18.3113 17.013 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C16.1006 2 19.6248 4.46819 21.1679 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M17 8H21.4C21.7314 8 22 7.73137 22 7.4V3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>
                        <button class="ctrl" v-else @click="refresh" v-ripple title="Reload stream">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"> <path d="M17.5 8C17.5 8 19 9.5 19 12C19 14.5 17.5 16 17.5 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 5C20.5 5 23 7.5 23 12C23 16.5 20.5 19 20.5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.5 8C6.5 8 5 9.5 5 12C5 14.5 6.5 16 6.5 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.5 5C3.5 5 1 7.5 1 12C1 16.5 3.5 19 3.5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>

                        <button class="ctrl sm" @click="toggleMute" v-ripple :title="muted ? 'Unmute' : 'Mute'">
                            <svg v-if="muted" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"> <path d="M17 14L19.0005 12M21 10L19.0005 12M19.0005 12L17 10M19.0005 12L21 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3 14V10C3 9.44772 3.44772 9 4 9H6.69722C6.89465 9 7.08766 8.94156 7.25192 8.83205L11.4453 6.03647C12.1099 5.59343 13 6.06982 13 6.86852V17.1315C13 17.9302 12.1099 18.4066 11.4453 17.9635L7.25192 15.1679C7.08766 15.0584 6.89465 15 6.69722 15H4C3.44772 15 3 14.5523 3 14Z" stroke="currentColor" stroke-width="1.5"/> </svg>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"> <path d="M2 14V10C2 9.44772 2.44772 9 3 9H5.69722C5.89465 9 6.08766 8.94156 6.25192 8.83205L10.4453 6.03647C11.1099 5.59343 12 6.06982 12 6.86852V17.1315C12 17.9302 11.1099 18.4066 10.4453 17.9635L6.25192 15.1679C6.08766 15.0584 5.89465 15 5.69722 15H3C2.44772 15 2 14.5523 2 14Z" stroke="currentColor" stroke-width="1.5"/> <path d="M16.5 7.5C16.5 7.5 18 9 18 11.5C18 14 16.5 15.5 16.5 15.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M19.5 4.5C19.5 4.5 22 7 22 11.5C22 16 19.5 18.5 19.5 18.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>
                    </div>

                    <div class="transport game-transport" :class="{ disabled: disableControls }" v-else>
                        <button class="ctrl sm" @click="startVirtualInput" v-ripple title="Virtual input">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"> <path d="M4 10V14C4 18.4183 7.58172 22 12 22C16.4183 22 20 18.4183 20 14V9C20 5.13401 16.866 2 13 2H12C7.58172 2 4 5.58172 4 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/> <path d="M12 2V8.4C12 8.73137 12.2686 9 12.6 9H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/> </svg>
                        </button>

                        <button class="ctrl" @click="esc" v-ripple title="Back">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"> <path d="M6.75827 17.2426L12.0009 12M17.2435 6.75736L12.0009 12M12.0009 12L6.75827 6.75736M12.0009 12L17.2435 17.2426" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>

                        <button class="ctrl primary safe" @click="stop" v-ripple title="Stop">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"> <path d="M21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>

                        <button class="ctrl" @click="enter" v-ripple title="Select">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"> <path d="M13.25 19.25L16.75 15.75L13.25 12.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M16.75 15.75H10.75C8.54086 15.75 6.75 13.9591 6.75 11.75V4.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>

                        <button class="ctrl sm" @click="toggleGameTools" :class="{ active: gameToolDrawerOpen }" v-ripple title="Game tools">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"> <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M19.6224 10.3954L18.5247 7.7448L20 6L18 4L16.2647 5.48295L13.5578 4.36974L12.9353 2H10.981L10.3491 4.40113L7.70441 5.51596L6 4L4 6L5.45337 7.78885L4.3725 10.4463L2 11V13L4.40111 13.6555L5.51575 16.2997L4 18L6 20L7.79116 18.5403L10.397 19.6123L11 22H13L13.6045 19.6132L16.2551 18.5155C16.6969 18.8313 18 20 18 20L20 18L18.5159 16.2494L19.6139 13.598L21.9999 12.9772L22 11L19.6224 10.3954Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>
                    </div>

                    <transition name="fade">
                        <div class="drawer game-tools-drawer" v-if="gameToolDrawerOpen">
                            <GameToolbox :inline="true" />
                        </div>
                    </transition>

                    <transition name="fade">
                        <div class="vip-banner" v-if="vipMode">
                            <span>Virtual input active</span>
                            <button @click="endVirtualInput" v-ripple>End</button>
                        </div>
                    </transition>
                </div>
            </template>

            <div class="remote-empty" v-else>
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M8.5 12h7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                <p>Nothing playing right now</p>
                <span>Start something on your device and the controls will show up here.</span>
            </div>
        </div>
    </transition>
</template>

<script>
import io from 'socket.io-client'
import DidSettings from '@/components/DidSettings.vue'
import GameToolbox from '@/components/GameToolbox.vue'

export default {
    name: 'DesktopRemote',

    props: {
        open: Boolean,
    },

    components: {
        DidSettings,
        GameToolbox,
    },

    data() {
        return {
            socket: null,
            media: null,
            type: null,
            playing: true,
            muted: false,
            currentTime: 0,
            playerIndex: -1,
            upNext: [],
            disableControls: false,
            actionDrawerOpen: false,
            didDrawerOpen: false,
            gameToolDrawerOpen: false,
            vipMode: false,
            isDragging: false,
        }
    },

    computed: {
        progress() {
            if (!this.media) return 0
            return (this.currentTime / (this.media.duration || 1)) * 100
        },

        showOrMovie() {
            return this.type === 'od'
        },

        isDuel() {
            return this.type === 'sport' && this.media && this.media.logos && this.media.logos.length === 2
        },

        isPoster() {
            return this.type === 'od' && !!(this.media && this.media.logos && this.media.logos[0])
        },

        sportIcon() {
            if (this.type !== 'sport' || !this.media || !window.sportsData) return null
            const keywordsByName = {
                'Football': ['nfl', 'football'],
                'Formula1': ['f1', 'formula'],
                'Basketball': ['nba', 'basketball'],
                'MMA': ['ufc', 'mma'],
                'Hockey': ['nhl', 'hockey'],
                'Baseball': ['mlb', 'baseball'],
                'Soccer': ['fifa', 'soccer'],
            }
            const haystack = this.media.ref.toLowerCase()
            const match = window.sportsData.find((s) => {
                const keywords = keywordsByName[s.name] || [s.name.toLowerCase()]
                return keywords.some((k) => haystack.includes(k))
            })
            return match ? match.img : null
        },

        headerArt() {
            if (this.type === 'sport') return this.sportIcon
            return (this.media && this.media.logos && this.media.logos[0]) || null
        },

        accentColor() {
            return (this.media && this.media.color) ? this.media.color : '#8b8b93'
        },

        typeLabel() {
            return { live: 'Live TV', od: 'On Demand', sport: 'Sports', game: 'Game' }[this.type] || ''
        },
    },

    mounted() {
        if (!this.socket) {
            this.socket = io(process.env.VUE_APP_SERVER + '/')
        }

        this.socket.on('gameStream', (x) => { this.$root.$emit('gameStream', x); })
        this.socket.on('gameParty', (x) => { this.$root.$emit('gameParty', x); })

        this.socket.on('newRemote', (x) => {
            if (window.did !== x.did) return
            this.updateRemote(x)
        })

        this.socket.on('mediaReady', (x) => {
            if (window.did !== x.did) return
            this.disableControls = false
            if (this.media) this.media.duration = x.duration
        })

        this.socket.on('mediaNotReady', (x) => {
            if (window.did !== x.did) return
            this.disableControls = true
        })

        this.socket.on('time', (x) => {
            if (window.did !== x.did) return
            if (this.isDragging) return
            this.currentTime = x.time
        })

        this.$root.$on('getRemote', this.getRemotes)
        this.getRemotes()
    },

    beforeDestroy() {
        this.$root.$off('getRemote', this.getRemotes)
        window.removeEventListener('mousemove', this.onScrubMove)
        window.removeEventListener('mouseup', this.onScrubEnd)
        if (this.socket) {
            this.socket.disconnect()
            this.socket = null
        }
    },

    methods: {
        getRemotes() {
            if (!window.did) {
                this.media = null
                return
            }
            window.afetch('/now_playing?did=' + window.did)
                .then(r => r.json())
                .then(data => {
                    this.updateRemote(data)
                })
        },

        updateRemote(x) {
            if (!x || !x.media || x.media.type === undefined) {
                this.type = null
                this.media = null
                return
            }
            this.currentTime = x.media.time
            this.type = x.media.type
            this.media = x.media
            this.upNext = x.upNext || []
            this.playing = x.playing
            this.muted = x.muted
            if (this.upNext.length > 0) {
                this.playerIndex = this.upNext.findIndex(y => y.id === x.media.id)
            }
        },

        formatTime(seconds) {
            if (!seconds) return '00:00'
            const h = Math.floor(seconds / 3600)
            const m = Math.floor((seconds % 3600) / 60)
            const s = Math.floor(seconds % 60)
            if (h > 0) return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
            return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
        },

        fallbackImg(event) {
            event.target.src = ''
        },

        toggleDidDrawer() {
            this.didDrawerOpen = !this.didDrawerOpen
            this.actionDrawerOpen = false
            this.gameToolDrawerOpen = false
        },
        toggleActionDrawer() {
            this.actionDrawerOpen = !this.actionDrawerOpen
            this.didDrawerOpen = false
            this.gameToolDrawerOpen = false
        },
        toggleGameTools() {
            this.gameToolDrawerOpen = !this.gameToolDrawerOpen
            this.didDrawerOpen = false
            this.actionDrawerOpen = false
        },
        closeAllDrawers() {
            this.didDrawerOpen = false
            this.actionDrawerOpen = false
            this.gameToolDrawerOpen = false
        },

        onScrubStart(event) {
            this.isDragging = true
            this.updateTimeFromClientX(event.clientX)
            window.addEventListener('mousemove', this.onScrubMove)
            window.addEventListener('mouseup', this.onScrubEnd)
        },
        onScrubMove(event) {
            if (!this.isDragging) return
            this.updateTimeFromClientX(event.clientX)
        },
        onScrubEnd() {
            if (!this.isDragging) return
            this.isDragging = false
            window.removeEventListener('mousemove', this.onScrubMove)
            window.removeEventListener('mouseup', this.onScrubEnd)
            this.seekTo()
        },
        updateTimeFromClientX(clientX) {
            const el = this.$refs.scrubTrack
            if (!el || !this.media) return
            const rect = el.getBoundingClientRect()
            const pct = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width))
            this.currentTime = pct * (this.media.duration || 0)
        },
        seekTo() {
            window.afetch(`/seek?did=${window.did}&t=${this.currentTime}`)
        },

        togglePlayPause() {
            this.playing = !this.playing
            window.afetch(`/togglePlay?did=${window.did}`)
        },

        toggleMute() {
            this.muted = !this.muted
            window.afetch(`/toggleMute?did=${window.did}`)
        },

        toggleCC() {
            window.afetch(`/toggleCaptions?did=${window.did}`)
        },

        toggleAT() {
            window.afetch(`/toggleAudioTrack?did=${window.did}`)
        },

        fullscreen() {
            window.afetch(`/fullscreen?did=${window.did}`)
        },

        refresh() {
            window.afetch(`/jump?did=${window.did}`)
        },

        skipIntro() {
            window.afetch(`/tab?did=${window.did}`)
        },

        getBack() {
            if (this.media && this.media.ref) {
                window.location.href = this.media.ref
            }
        },

        esc() {
            window.afetch(`/esc?did=${window.did}`)
        },

        enter() {
            window.afetch(`/enter?did=${window.did}`)
        },

        startVirtualInput() {
            window.afetch(`/startVirtualInput?did=${window.did}`)
            this.vipMode = true
            setTimeout(() => {
                window.open('http://wr2.studio14a.com:5566/', '_blank')
            }, 800)
        },
        endVirtualInput() {
            window.afetch(`/endVirtualInput?did=${window.did}`)
            this.vipMode = false
        },

        stop() {
            this.closeAllDrawers()
            this.vipMode = false
            this.media = null
            this.type = null
            window.afetch(`/home?did=${window.did}`)
            window.did = null
            sessionStorage.removeItem('lastDid')
            this.$emit('close')
        },

        change(i) {
            this.currentTime = 0
            if (this.media) this.media.duration = 0
            if (i !== undefined) {
                this.playerIndex = i
            }
            window.afetch(`/queue?did=${window.did}&i=${this.playerIndex}`)
        },

        next() {
            if (this.media && this.media.type === 'live') {
                if (this.playerIndex < 54) {
                    this.playerIndex++
                    this.change()
                }
            }
            if (this.type === 'od') {
                this.change(1)
            }
        },

        prev() {
            if (this.media && this.media.type === 'live') {
                if (this.playerIndex > 0) {
                    this.playerIndex--
                    this.change()
                }
            }
            if (this.type === 'od') {
                this.change(-1)
            }
        },

        ff() {
            window.afetch(`/ff?did=${window.did}`)
        },

        rw() {
            window.afetch(`/rw?did=${window.did}`)
        },
    },
}
</script>

<style lang="scss" scoped>
.desktop-remote {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    width: 360px;
    background-color: rgba(17, 17, 19, 0.94);
    backdrop-filter: blur(24px);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 20px;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(255, 255, 255, 0.02);
    z-index: 1001;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Inter, sans-serif;
    color: #f5f5f4;
}

.remote-pop-enter-active,
.remote-pop-leave-active {
    transition: opacity 0.18s ease, transform 0.22s cubic-bezier(0.22, 1, 0.36, 1);
}
.remote-pop-enter,
.remote-pop-leave-to {
    opacity: 0;
    transform: translateY(-10px) scale(0.97);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease, transform 0.15s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}

.remote-glow {
    position: absolute;
    top: -90px;
    left: 50%;
    width: 220px;
    height: 180px;
    transform: translateX(-50%);
    background: radial-gradient(closest-side, var(--accent), transparent 72%);
    opacity: 0.3;
    filter: blur(38px);
    pointer-events: none;
    z-index: 0;
    animation: breathe 7s ease-in-out infinite;
}
@keyframes breathe {
    0%, 100% { opacity: 0.22; transform: translateX(-50%) scale(1); }
    50% { opacity: 0.38; transform: translateX(-50%) scale(1.1); }
}
@media (prefers-reduced-motion: reduce) {
    .remote-glow { animation: none; }
}

.remote-header {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 14px 14px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    gap: 8px;

    .device-trigger {
        display: flex;
        align-items: center;
        gap: 10px;
        min-width: 0;
        background: none;
        border: none;
        padding: 4px 6px;
        margin-left: -6px;
        border-radius: 10px;
        cursor: pointer;
        color: inherit;
        transition: background-color 0.15s;

        &:hover, &.active {
            background-color: rgba(255, 255, 255, 0.06);
        }

        .device-art {
            width: 30px;
            height: 30px;
            border-radius: 7px;
            overflow: hidden;
            flex-shrink: 0;
            background: rgba(255, 255, 255, 0.06);
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .device-text {
            display: flex;
            flex-direction: column;
            min-width: 0;
            text-align: left;

            .device-name {
                font-size: 13px;
                font-weight: 600;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 190px;
            }

            .device-meta {
                display: flex;
                align-items: center;
                gap: 5px;
                font-size: 10.5px;
                color: rgba(255, 255, 255, 0.4);
            }
        }

        .chev {
            flex-shrink: 0;
            color: rgba(255, 255, 255, 0.35);
            transition: transform 0.2s ease;
            &.open { transform: rotate(180deg); }
        }
    }

    .no-device {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.4);
        padding: 4px 6px;
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 2px;
        flex-shrink: 0;
    }

    .icon-btn {
        background: none;
        border: none;
        color: rgba(255, 255, 255, 0.45);
        cursor: pointer;
        padding: 7px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: color 0.15s, background-color 0.15s;

        &:hover, &.active {
            color: white;
            background-color: rgba(255, 255, 255, 0.1);
        }
    }
}

.live-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ef4444;
    flex-shrink: 0;
    animation: pulse-dot 1.8s ease-in-out infinite;
}
@keyframes pulse-dot {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.35; }
}
@media (prefers-reduced-motion: reduce) {
    .live-dot { animation: none; }
}

.drawer {
    position: absolute;
    z-index: 30;
    background-color: rgba(24, 24, 27, 0.98);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5);
    overflow: hidden;

    &.did-drawer, &.game-tools-drawer {
        top: 58px;
        left: 14px;
        right: 14px;
        padding: 14px;
    }

    &.action-drawer {
        top: 58px;
        right: 44px;
        width: 200px;
        padding: 6px;
    }

    .drawer-item {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px;
        border-radius: 9px;
        background: none;
        border: none;
        color: rgba(255, 255, 255, 0.85);
        font-size: 12.5px;
        cursor: pointer;
        text-align: left;
        transition: background-color 0.15s;

        &:hover { background-color: rgba(255, 255, 255, 0.08); }

        svg { flex-shrink: 0; color: rgba(255, 255, 255, 0.6); }
    }
}

.drawer-catch {
    position: fixed;
    inset: 0;
    z-index: 20;
}

.remote-body {
    position: relative;
    z-index: 1;
    padding: 22px 20px 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.media-art {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    width: 100%;
    min-height: 64px;
    margin-bottom: 14px;

    img {
        display: block;
        pointer-events: none;
    }

    &.single img {
        max-width: 100px!important;
        max-height: 100px!important;
        object-fit: contain;
        filter: drop-shadow(0 10px 24px rgba(0, 0, 0, 0.45));
    }

    &.poster {
        min-height: 176px;

        img {
            max-width: 210px;
            //max-height: 210px;
            width: auto;
            height: auto;
            object-fit: contain;
            border-radius: 12px;
            filter: drop-shadow(0 14px 30px rgba(0, 0, 0, 0.5));
        }
    }


    &.single {
        padding: 48px 0;
    }

    &.duel {
        padding: 48px 0;
        .team-logo {
            width: 56px;
            height: 56px;
            border-radius: 12px;
            background: rgba(255, 255, 255, 0.05);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px;

            img { max-width: 100%; max-height: 100%; object-fit: contain; }
        }

        .vs-chip {
            font-size: 11px;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.4);
            padding: 3px 8px;
            border-radius: 999px;
            border: 1px solid rgba(255, 255, 255, 0.12);
        }
    }

    .team-logo.multi {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        img { max-width: 100%; max-height: 100%; object-fit: contain; }
    }
}

.media-title-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    margin-bottom: 16px;

    .chan-btn {
        flex-shrink: 0;
        background: rgba(255, 255, 255, 0.06);
        border: none;
        color: rgba(255, 255, 255, 0.7);
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.15s, color 0.15s;

        &:hover { background-color: rgba(255, 255, 255, 0.14); color: white; }
    }

    .media-title {
        min-width: 0;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        padding: 0 24px;

        h3 {
            margin: 0;
            font-size: 15px;
            font-weight: 600;
            max-width: 240px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .type-tag {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            font-size: 10.5px;
            color: var(--accent);
            filter: brightness(1.35) saturate(1.1);
        }
    }
}

.scrub {
    width: 100%;
    margin-bottom: 16px;
}
.scrub-track {
    position: relative;
    width: 100%;
    height: 20px;
    cursor: pointer;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        height: 3px;
        transform: translateY(-50%);
        border-radius: 4px;
        background-color: rgba(255, 255, 255, 0.15);
    }
}
.scrub-fill {
    position: absolute;
    left: 0;
    top: 50%;
    height: 3px;
    transform: translateY(-50%);
    border-radius: 4px;
    background: var(--accent);
    pointer-events: none;
}
.scrub-thumb {
    position: absolute;
    top: 50%;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
    transform: translate(-50%, -50%) scale(1);
    transition: transform 0.15s ease-out;
    pointer-events: none;
}
.scrub-track.dragging .scrub-thumb {
    transform: translate(-50%, -50%) scale(1.4);
}
.scrub-times {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    font-variant-numeric: tabular-nums;
    color: rgba(255, 255, 255, 0.4);
    padding-top: 6px;
}

.transport {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;

    &.disabled > .ctrl:not(.safe) {
        opacity: 0.25;
        pointer-events: none;
    }
}

.ctrl {
    background: rgba(255, 255, 255, 0.05);
    border: none;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.15s, color 0.15s, transform 0.1s;

    &:hover {
        color: white;
        background-color: rgba(255, 255, 255, 0.12);
    }
    &:active {
        transform: scale(0.92);
    }

    &.sm {
        width: 32px;
        height: 32px;
    }

    &.primary {
        width: 50px;
        height: 50px;
        margin: 0 4px;
        color: #111;
        background: linear-gradient(160deg, #fff, rgba(255, 255, 255, 0.85));
        box-shadow: 0 6px 18px -4px var(--accent);

        &:hover {
            background: #fff;
        }
    }
}

.game-transport .ctrl.primary {
    background: linear-gradient(160deg, #fff, rgba(255, 255, 255, 0.85));
    color: #111;
}

.vip-banner {
    margin-top: 14px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    font-size: 11.5px;
    color: rgba(255, 255, 255, 0.75);

    button {
        flex-shrink: 0;
        background: rgba(255, 255, 255, 0.12);
        border: none;
        color: white;
        font-size: 11px;
        font-weight: 600;
        padding: 5px 10px;
        border-radius: 6px;
        cursor: pointer;

        &:hover { background: rgba(255, 255, 255, 0.2); }
    }
}

.remote-empty {
    position: relative;
    z-index: 1;
    padding: 34px 22px 30px;
    text-align: center;
    color: rgba(255, 255, 255, 0.55);

    svg { opacity: 0.35; margin-bottom: 10px; }

    p {
        margin: 0 0 4px;
        font-size: 13px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.75);
    }

    span {
        display: block;
        font-size: 11.5px;
        color: rgba(255, 255, 255, 0.4);
        max-width: 240px;
        margin: 0 auto;
    }
}
</style>
